import React from "react";
import "./wsp.css";
import wspBtn from "../../assets/images/WhatsAppButtonWhiteSmall.png";

const Wsp = () => {
  return (
    <div>
      <a
        href="https://wa.me/5493815574043"
        className="btn_wsp"
        target="_blank"
        rel="noreferrer"
      >
        <img src={wspBtn} alt="whatsapp chat button" />
      </a>
    </div>
  );
};

export default Wsp;
